/**
 * Contact form response handling. Success is shown only when the backend
 * explicitly acknowledges that it stored the message ({status: "received"});
 * any other response, including a bare 200, is treated as not accepted.
 */
export function contactSubmissionAccepted(response) {
  return !!(response && response.status === 200 && response.data && response.data.status === 'received');
}

export function contactErrorMessage(error) {
  const response = error && error.response ? error.response : null;
  const status = response ? response.status : 0;
  const body = response && response.data ? response.data : {};
  if (status === 422 && Array.isArray(body.errors)) {
    return {
      captcha: false,
      text: body.errors.indexOf('email') !== -1
        ? 'Please enter a valid email address.'
        : 'Please check your details and try again.',
    };
  }
  if (status === 422) {
    return { captcha: true, text: 'Please confirm that you are not a robot.' };
  }
  if (status === 429) {
    return { captcha: false, text: 'Too many attempts. Please wait a few minutes and try again.' };
  }
  return { captcha: true, text: 'Your message could not be sent right now. Please try again in a few minutes.' };
}
